/* eslint-disable jsx-a11y/media-has-caption */

import React from 'react';
import { Icon } from 'antd';

const QUARTERLY_FINANCIAL_RESULTS_PDFS = {
  Q1_2023_2024: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financials/quarterly-financial-results/quarterly-financial-results-zaggle-Q1-FY-24.pdf',
  Q2_2023_2024: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financials/quarterly-financial-results/quarterly-financial-results-zaggle-Q2-FY-24.pdf',
};

const INVESTOR_PRESENTATION_PDFS = {
  Q1_2023_2024: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financials/investor-presentation/investor-presentation-zaggle-Q1-FY-24.pdf',
  Q2_2023_2024: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financials/investor-presentation/investor-presentation-zaggle-Q2-FY-24.pdf',
};

const PRESS_RELEASE_PDFS = {
  Q1_2023_2024: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financials/press-release/press-release-zaggle-Q1-FY-24.pdf',
  Q2_2023_2024: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financials/press-release/press-release-zaggle-Q2-FY-24.pdf',
};

const EARNING_CALL_TRANSCRIPT_PDFS = {
  PDF_Q1_2023_2024: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financials/earning-call-transcript/pdf-files/zaggle-earning-call-transcript-Q1FY24.pdf',
  PDF_Q2_2023_2024: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financials/earning-call-transcript/pdf-files/zaggle-earning-call-transcript-Q2FY24.pdf',

  AUDIO_Q1_2023_2024: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financials/earning-call-transcript/audio-files/zaggle_earning_call_transcript_Q1FY24.mp3',
  AUDIO_Q2_2023_2024: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financials/earning-call-transcript/audio-files/zaggle_earning_call_transcript_Q2FY24.mp3',
};

const INTIMATION_EARNING_CALL_PDFS = {
  Q1_2023_2024: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financials/intimation-of-earning-call-Q1FY23-24.pdf',
  Q2_2023_2024: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financials/Intimation-of-earning-call/intimation-of-earning-call-Q2FY23-24.pdf',
};


const FINANCIAL_RESULTS_COLUMNS = [
  {
    title: 'Financial Year',
    dataIndex: 'fy',
    key: 'fy',
  },
  {
    title: 'Q1',
    dataIndex: 'q1',
    key: 'q1',
    align: 'center',
  },
  {
    title: 'Q2',
    dataIndex: 'q2',
    key: 'q2',
    align: 'center',
  },
  {
    title: 'Q3',
    dataIndex: 'q3',
    key: 'q3',
    align: 'center',
  },
  {
    title: 'Q4',
    dataIndex: 'q4',
    key: 'q4',
    align: 'center',
  },
];

const QUARTERLY_FINANCIAL_RESULTS = [
  {
    key: 0,
    fy: '2023-24',
    q1:
  <a href={QUARTERLY_FINANCIAL_RESULTS_PDFS.Q1_2023_2024} target="_blank" >
    <Icon type="file-pdf" className="font-22 text-red" />
  </a>,
    q2:
  <a href={QUARTERLY_FINANCIAL_RESULTS_PDFS.Q2_2023_2024} target="_blank" >
    <Icon type="file-pdf" className="font-22 text-red" />
  </a>,
    q3: '',
    q4: '',
  },
];

const INVESTOR_PRESENTATION = [
  {
    key: 0,
    fy: '2023-24',
    q1:
  <a href={INVESTOR_PRESENTATION_PDFS.Q1_2023_2024} target="_blank" >
    <Icon type="file-pdf" className="font-22 text-red" />
  </a>,
    q2:
  <a href={INVESTOR_PRESENTATION_PDFS.Q2_2023_2024} target="_blank" >
    <Icon type="file-pdf" className="font-22 text-red" />
  </a>,
    q3: '',
    q4: '',
  },
];

const PRESS_RELEASE = [
  {
    key: 0,
    fy: '2023-24',
    q1:
  <a href={PRESS_RELEASE_PDFS.Q1_2023_2024} target="_blank" >
    <Icon type="file-pdf" className="font-22 text-red" />
  </a>,
    q2:
  <a href={PRESS_RELEASE_PDFS.Q2_2023_2024} target="_blank" >
    <Icon type="file-pdf" className="font-22 text-red" />
  </a>,
    q3: '',
    q4: '',
  },
];

const EARNING_CALL_TRANSCRIPT_COLOUMNS = [
  {
    title: 'Financial Year of Quaterly Call Transcripts',
    dataIndex: 'financial_year_name',
    key: 'financial_year_name',
    width: '350px',
  },
  {
    title: 'PDF Files',
    dataIndex: 'pdf_files',
    key: 'pdf_files',
    align: 'center',
    width: '300px',
  },
  {
    title: 'Audio Files',
    dataIndex: 'audio_files',
    key: 'audio_files',
    align: 'center',
  },
];

const EARNING_CALL_TRANSCRIPT = [
  {
    key: 0,
    financial_year_name: 'Zaggle Earning Call Transcript Q1FY24',
    pdf_files:
  <a href={EARNING_CALL_TRANSCRIPT_PDFS.PDF_Q1_2023_2024} target="_blank" >
    <Icon type="file-pdf" className="font-22 text-red" />
  </a>,
    audio_files:
  <audio controls>
    <source src={EARNING_CALL_TRANSCRIPT_PDFS.AUDIO_Q1_2023_2024} type="audio/mpeg" />
  </audio>,
  },
  {
    key: 1,
    financial_year_name: 'Zaggle Earning Call Transcript Q2FY24',
    pdf_files:
  <a href={EARNING_CALL_TRANSCRIPT_PDFS.PDF_Q2_2023_2024} target="_blank" >
    <Icon type="file-pdf" className="font-22 text-red" />
  </a>,
    audio_files:
  <audio controls>
    <source src={EARNING_CALL_TRANSCRIPT_PDFS.AUDIO_Q2_2023_2024} type="audio/mpeg" />
  </audio>,
  },
];

const INTIMATION_EARNING_CALL = [
  {
    key: 0,
    fy: '2023-24',
    q1:
  <a href={INTIMATION_EARNING_CALL_PDFS.Q1_2023_2024} target="_blank" >
    <Icon type="file-pdf" className="font-22 text-red" />
  </a>,
    q2:
  <a href={INTIMATION_EARNING_CALL_PDFS.Q2_2023_2024} target="_blank" >
    <Icon type="file-pdf" className="font-22 text-red" />
  </a>,
    q3: '',
    q4: '',
  },
];

export {
  FINANCIAL_RESULTS_COLUMNS,
  QUARTERLY_FINANCIAL_RESULTS,
  INVESTOR_PRESENTATION,
  PRESS_RELEASE,
  EARNING_CALL_TRANSCRIPT,
  EARNING_CALL_TRANSCRIPT_COLOUMNS,
  INTIMATION_EARNING_CALL,
};



// WEBPACK FOOTER //
// client/containers/StaticPages/IPO/Financials/constants.js